import { $getSelection, LexicalEditor } from 'lexical';
import { useTheme } from '@mui/material/styles';
import { $patchStyleText } from '@lexical/selection';

import { MenuItem } from '../../../../../MenuItem';
import { Box } from '../../../../../Box';
import { Typography } from '../../../../../Typography';

export const useColorsItems = (editor: LexicalEditor, activeColor: string) => {
  const theme = useTheme();

  const ColorTypeToBlockName = {
    [theme.tokens.colors.text.light.primary]: 'Черный',
    [theme.tokens.colors.text.light.secondary]: 'Серый',
    [theme.tokens.colors.original.brand.primary]: 'Синий',
    [theme.tokens.colors.accent.text.success]: 'Зеленый',
    [theme.tokens.colors.accent.text.warning]: 'Оранжевый',
    [theme.tokens.colors.accent.text.error]: 'Красный',
    [theme.tokens.colors.accent.text.review]: 'Фиолетовый',
    [theme.tokens.colors.accent.text.violet]: 'Сливовый',
  } as const;

  const applyStyleText = (styles: Record<string, string>) => {
    editor.update(() => {
      const selection = $getSelection();

      if (selection !== null) {
        $patchStyleText(selection, styles);
      }
    });
  };

  const onFontColorSelect = (value: string, type: 'color') => {
    applyStyleText({ [type]: value });
  };
  return Object.entries(ColorTypeToBlockName).map(([color, name]) => (
    <MenuItem onClick={() => onFontColorSelect(color, 'color')} key={color}>
      <Box display="flex" alignItems="center" gap="8">
        <Box
          width="16px"
          height="16px"
          radius="xs"
          style={{ backgroundColor: color }}
        />
        <Typography
          variant="body3"
          color={
            activeColor === color
              ? 'original.brand.primary'
              : 'text.light.primary'
          }
        >
          {name}
        </Typography>
      </Box>
    </MenuItem>
  ));
};
